import userNotificationApi from "api/services/user-notifications";
import userNotificationCaApi from "api/services/user-notifications-ca";
import logError from "utils/logError";

const postUserNotificationDismiss = async (countryCode: string) => {
  const api =
    countryCode === "CA" ? userNotificationCaApi : userNotificationApi;
  try {
    await api.post(`/v2/user/dismissals`, {
      createdBefore: new Date().toISOString(),
    });

    return true;
  } catch (error) {
    logError(error.message, {
      functionName: "postUserNotificationDismiss",
      service: "usernotification",
      statusCode: error.statusCode,
    });
    return false;
  }
};

export default postUserNotificationDismiss;
